import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-h', 'IconLetterH', [
  ['path', { d: 'M17 4l0 16', key: 'svg-0' }],
  ['path', { d: 'M7 12l10 0', key: 'svg-1' }],
  ['path', { d: 'M7 4l0 16', key: 'svg-2' }],
]);
